import { library } from '@fortawesome/fontawesome-svg-core';
import { faBars, faTimes, faPaperPlane, faEnvelope, faMapMarkerAlt, faClock, faGraduationCap } from '@fortawesome/free-solid-svg-icons';
import { faLinkedinIn, faDribbble, faBehance, faGithub } from '@fortawesome/free-brands-svg-icons';

library.add(
  faBars, 
  faTimes, 
  faPaperPlane,
  faEnvelope,
  faMapMarkerAlt,
  faClock,
  faGraduationCap,
  faLinkedinIn,
  faDribbble,
  faBehance,
  faGithub
);